import { jsx as o } from "react/jsx-runtime";
import { MetricVisitsIcon as i } from "./index.es413.js";
import { MetricVisitFrequencyIcon as r } from "./index.es414.js";
import { MetricVenuesIcon as t } from "./index.es412.js";
import { MetricUnmetDemandIcon as p } from "./index.es411.js";
import { MetricStoreSupplyIcon as m } from "./index.es409.js";
import { MetricStoreSupply2Icon as c } from "./index.es408.js";
import { MetricStoreIcon as n } from "./index.es407.js";
import { MetricStoreDemandIcon as s } from "./index.es406.js";
import { MetricSelectedIcon as a } from "./index.es405.js";
import { MetricSalesIcon as f } from "./index.es404.js";
import { MetricRiskIcon as x } from "./index.es403.js";
import { MetricPopulationIcon as I } from "./index.es402.js";
import { MetricPopulationDensityIcon as z } from "./index.es401.js";
import { MetricOverlapIcon as M } from "./index.es400.js";
import { MetricLocationIcon as l } from "./index.es399.js";
import { MetricLoadingIcon as e } from "./index.es417.js";
import { MetricIndustrialIcon as u } from "./index.es398.js";
import { MetricIncomePerPersonIcon as d } from "./index.es397.js";
import { MetricHouseholdIncomeIcon as h } from "./index.es396.js";
import { MetricHouseholdAgeIcon as v } from "./index.es395.js";
import { MetricHouseIcon as S } from "./index.es394.js";
import { MetricHeartIcon as b } from "./index.es393.js";
import { MetricFrequentCoTenantsIcon as y } from "./index.es392.js";
import { MetricFootTrafficIcon as g } from "./index.es391.js";
import { MetricFavoritesIcon as C } from "./index.es390.js";
import { MetricExpansionRateIcon as F } from "./index.es389.js";
import { MetricErrorIcon as P } from "./index.es416.js";
import { MetricEmailSentIcon as q } from "./index.es415.js";
import { MetricDemographicsIcon as A } from "./index.es388.js";
import { MetricCrimeIcon as D } from "./index.es387.js";
import { MetricCommentsIcon as H } from "./index.es386.js";
import { MetricCoTenantsIcon as E } from "./index.es385.js";
import { MetricCannibalizationIcon as T } from "./index.es384.js";
import { MetricBulbIcon as V } from "./index.es383.js";
import { MetricBaseForecastIcon as k } from "./index.es382.js";
import { MetricAttributeImpactIcon as B } from "./index.es381.js";
import { MetricApproveIcon as L } from "./index.es380.js";
const yo = {
  approve: /* @__PURE__ */ o(L, { size: "40px" }),
  "attribute-impact": /* @__PURE__ */ o(B, { size: "40px" }),
  "base-forecast": /* @__PURE__ */ o(k, { size: "40px" }),
  bulb: /* @__PURE__ */ o(V, { size: "40px" }),
  cannibalization: /* @__PURE__ */ o(T, { size: "40px" }),
  "co-tenants": /* @__PURE__ */ o(E, { size: "40px" }),
  comments: /* @__PURE__ */ o(H, { size: "40px" }),
  crime: /* @__PURE__ */ o(D, { size: "40px" }),
  demographics: /* @__PURE__ */ o(A, { size: "40px" }),
  "email-sent": /* @__PURE__ */ o(q, { size: "40px" }),
  error: /* @__PURE__ */ o(P, { size: "40px" }),
  "expansion-rate": /* @__PURE__ */ o(F, { size: "40px" }),
  favorites: /* @__PURE__ */ o(C, { size: "40px" }),
  "foot-traffic": /* @__PURE__ */ o(g, { size: "40px" }),
  "frequent-co-tenants": /* @__PURE__ */ o(y, { size: "40px" }),
  heart: /* @__PURE__ */ o(b, { size: "40px" }),
  house: /* @__PURE__ */ o(S, { size: "40px" }),
  "household-age": /* @__PURE__ */ o(v, { size: "40px" }),
  "household-income": /* @__PURE__ */ o(h, { size: "40px" }),
  "income-per-person": /* @__PURE__ */ o(d, { size: "40px" }),
  industrial: /* @__PURE__ */ o(u, { size: "40px" }),
  loading: /* @__PURE__ */ o(e, { size: "40px" }),
  "loading-animated": /* @__PURE__ */ o(e, { size: "40px", animated: !0 }),
  location: /* @__PURE__ */ o(l, { size: "40px" }),
  overlap: /* @__PURE__ */ o(M, { size: "40px" }),
  "population-density": /* @__PURE__ */ o(z, { size: "40px" }),
  population: /* @__PURE__ */ o(I, { size: "40px" }),
  risk: /* @__PURE__ */ o(x, { size: "40px" }),
  sales: /* @__PURE__ */ o(f, { size: "40px" }),
  selected: /* @__PURE__ */ o(a, { size: "40px" }),
  "store-demand": /* @__PURE__ */ o(s, { size: "40px" }),
  store: /* @__PURE__ */ o(n, { size: "40px" }),
  "store-supply-2": /* @__PURE__ */ o(c, { size: "40px" }),
  "store-supply": /* @__PURE__ */ o(m, { size: "40px" }),
  "unmet-demand": /* @__PURE__ */ o(p, { size: "40px" }),
  venues: /* @__PURE__ */ o(t, { size: "40px" }),
  "visit-frequency": /* @__PURE__ */ o(r, { size: "40px" }),
  visits: /* @__PURE__ */ o(i, { size: "40px" })
};
export {
  yo as ICON_MAP
};
//# sourceMappingURL=index.es751.js.map
